import React from 'react';

export const errorLayout = props => <div>{props.children}</div>;
